// News items data for the Resources tab
export const newsItems = [
  {
    id: 4,
    headline: "Manus AI Agent",
    summary: "Manus excels at various tasks in work and life, getting everything done while you rest.",
    date: "March 5, 2025",
    url: "https://manus.im/",
    image: "/resource4.jpg"
  },
  {
    id: 2,
    headline: "Step by Step guide to build a Marketing Landing page without code",
    summary: "Use an AI code editor in english with this guide by Riz",
    date: "March 25, 2025",
    url: "https://rizpabani.medium.com/how-to-build-a-high-converting-marketing-landing-page-in-cursor-no-code-needed-6ccb18950800",
    image: "/resource2.png"
  },
  {
    id: 1,
    headline: "Chat GPT release enhanced image rendering",
    summary: "Balaji shares his thoughts on the implications",
    date: "March 26, 2025",
    url: "https://x.com/balajis/status/1904987087361004029",
    image: "/balaji.jpg"
  },
  {
    id: 3,
    headline: "Google release Gemini 2.5",
    summary: "Now the best model in the market (by benchmarks)",
    date: "March 26, 2025",
    url: "https://blog.google/technology/google-deepmind/gemini-model-thinking-updates-march-2025/#gemini-2-5-thinking",
    image: "/resource3.png"
  },
  {
    id: 6,
    headline: "2027 Intelligence Explosion: Scott Alexander & Daniel Kokotajlo",
    summary: "Scott Alexander & Daniel Kokotajlo discuss their forecast for the 2027 AI intelligence explosion.",
    date: "April 3, 2025",
    url: "https://www.youtube.com/watch?v=htOvH12T7mU",
    image: "/resource6.jpg"
  },
  {
    id: 5,
    headline: "ChatGPT will now remember your old conversations",
    summary: "Long-term memory allows ChatGPT to reference details you discussed, even if you didn't manually save them.",
    date: "April 11, 2025",
    url: "https://www.theverge.com/news/646968/openai-chatgpt-long-term-memory-upgrade",
    image: "/resource5.png"
  },
  {
    id: 7,
    headline: "OpenAI's GPT-4.1 Is Here — And It's Free for Developers",
    summary: "GPT-4.1 model family is now available for free through platforms like Cursor, Windsurf, and GitHub Copilot.",
    date: "April 15, 2025",
    url: "https://rizpabani.medium.com/openais-gpt-4-1-is-here-and-it-s-free-for-developers-ba33176731b0",
    image: "/resource7.png"
  },
  {
    id: 10,
    headline: "OpenAI investigates sycophancy in GPT-4o responses",
    summary: "OpenAI explores the tendency of GPT-4o to agree with user opinions, analyzing causes and proposing solutions for more objective AI outputs.",
    date: "April 29, 2025",
    url: "https://openai.com/index/sycophancy-in-gpt-4o/",
    image: "/resource10.png"
  },
  {
    id: 8,
    headline: "OpenAI introduces Codex: AI that translates natural language to code",
    summary: "OpenAI Codex enables developers to turn natural language into code, powering tools like GitHub Copilot and expanding possibilities for software creation.",
    date: "May 16, 2025",
    url: "https://openai.com/index/introducing-codex/",
    image: "/resource9.png"
  },
  {
    id: 9,
    headline: "Google launches AI Ultra subscription plan",
    summary: "Google AI Ultra offers the highest access to Gemini, Flow, Whisk, NotebookLM, and more, with premium features for creators and professionals.",
    date: "May 20, 2025",
    url: "https://blog.google/products/google-one/google-ai-ultra/",
    image: "/resource8.png"
  },
  {
    id: 11,
    headline: "Introducing Claude 4",
    summary: "Anthropic announces Claude Opus 4 and Claude Sonnet 4, setting new standards for coding and AI agents. Claude Opus 4 is the world's best coding model with sustained performance on complex tasks.",
    date: "May 22, 2025",
    url: "https://www.anthropic.com/news/claude-4",
    image: "/resource11.png"
  },
  {
    id: 12,
    headline: "Perplexity Labs launches",
    summary: "Perplexity Labs debuts as a new initiative to empower developers and researchers with advanced AI tools, APIs, and resources, aiming to drive breakthroughs in information discovery and knowledge creation.",
    date: "May 29, 2025",
    url: "https://www.perplexity.ai/hub/blog/introducing-perplexity-labs",
    image: "/resource12.png"
  },
  {
    id: 13,
    headline: "OpenAI releases o3-pro",
    summary: "OpenAI has launched o3-pro, a new version of its o3 reasoning model, offering improved performance in science, education, programming, and business. O3-pro is now available for ChatGPT Pro, Team, and API users, and outperforms top models like Gemini 2.5 Pro and Claude 4 Opus on key benchmarks.",
    date: "June 10, 2025",
    url: "https://techcrunch.com/2025/06/10/openai-releases-o3-pro-a-souped-up-version-of-its-o3-ai-reasoning-model/",
    image: "/resource13.png"
  }
]; 